import React, { useEffect } from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import SignUp from './components/SignUp';
import Excerpt from './components/Excerpt';
import Reviews from './components/Reviews';
import Readers from './components/Readers';
import UpcomingBooks from './components/UpcomingBooks';
import Retailers from './components/Retailers';
import About from './components/About';
import BottomCTA from './components/BottomCTA';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Nav />
      <Hero />
      <SignUp />
      <Excerpt />
      <Reviews />
      <Readers />
      <UpcomingBooks />
      <Retailers />
      <About />
      <BottomCTA />
      <Footer />
    </>
  );
}

export default App;
